// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__He-nQ","controls":"styles_controls__3eJ5z","charLimit":"styles_charLimit__2wLhM","input":"styles_input__1-pe6","send":"styles_send__3qJDq"};